import React from 'react';

import { useAppDispatch, useAppSelector } from '../../../hooks/customHooks';
import { SContent, SIcon, STitle, SValue, SWrapper } from '../styles/CustomerListItem.styled';
import { setActiveCustomer } from '../../../features/customersSlice';
import { ICustomerDto } from '../../../api/client';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-light-svg-icons';

interface IProps {
  customer: ICustomerDto;
}

const CustomerListItem: React.FC<IProps> = ({ customer }) => {
  const activeCustomer = useAppSelector((state) => state.customers.activeCustomer);
  const dispatch = useAppDispatch();
  const isActive = activeCustomer?.sysPrin.sysPrin === customer.sysPrin.sysPrin;

  return (
    <SWrapper
      className="hoverable--darker"
      onClick={() => dispatch(setActiveCustomer({ customer, docTypeIdInUrl: undefined }))}
    >
      <SContent>
        <STitle active={isActive}>{customer.name}</STitle>
        <SValue active={isActive}>{customer.sysPrin.sysPrin}</SValue>
      </SContent>
      {isActive ? (
        <SIcon>
          <FontAwesomeIcon icon={faCheck} />
        </SIcon>
      ) : null}
    </SWrapper>
  );
};

export default CustomerListItem;
